<template>
  <div
    class="product-card"
    role="button"
    tabindex="0"
    @click="addProduct"
    @keydown.enter="addProduct"
    @keydown.space.prevent="addProduct"
  >
    <div class="product-visual" :class="product.visualClass">
      <img :src="productImage" :alt="productName" @error="handleImageError" />
      <span v-if="productBadge" class="product-badge">{{ productBadge }}</span>
      <span class="product-unit">{{ productUnit }}</span>
    </div>

    <div class="product-info">
      <h3>{{ productName }}</h3>
      <p>
        <span>{{ productBarcode }}</span>
        <span>
          {{ $t('retailSale.product.inStock', { stock: product.stock }) }}
        </span>
      </p>

      <div class="product-price-row">
        <strong>{{ formattedPrice }}</strong>
        <button type="button" @click.stop="addProduct">
          <i class="fas fa-plus"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { formatCurrency } from '../../utils/currency'

const defaultProductImage = require('@/assets/default-retail-product-muted.png')

export default {
  name: 'RetailSaleProductCard',
  props: {
    product: {
      type: Object,
      required: true
    },
    currency: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      imageError: false
    }
  },
  computed: {
    productImage() {
      return !this.imageError && this.product.image
        ? this.product.image
        : defaultProductImage
    },
    productName() {
      if (this.product.nameKey) return this.$t(this.product.nameKey)

      return this.currentLocale === 'kh'
        ? this.product.nameKh || this.product.name
        : this.product.name || this.product.nameKh
    },
    productBarcode() {
      return this.product.barcode || ''
    },
    productUnit() {
      return this.currentLocale === 'kh'
        ? this.product.unitKh || this.product.unit
        : this.product.unit || this.product.unitKh
    },
    currentLocale() {
      return this.$root.$i18n ? this.$root.$i18n.locale : 'en'
    },
    productBadge() {
      if (this.product.promotion) {
        return this.$t('retailSale.product.discountBadge', {
          discount: this.product.promotion.discount_rate
        })
      }

      return this.product.badgeKey
        ? this.$t(this.product.badgeKey)
        : this.product.badge
    },
    formattedPrice() {
      return formatCurrency(this.product.price, this.currency)
    }
  },
  methods: {
    handleImageError() {
      this.imageError = true
    },
    addProduct() {
      this.$emit('add', this.product)
    }
  }
}
</script>

<style scoped src="../../styles/product-card.css"></style>
